<template>
  <div class="wapper">
    <div class="num-box">
      <div class="search-box">
        <input v-model="keyword" class="search-input" placeholder="请输入案由、关键词、法院、当事人、律师" type="text">
        <el-button class="search-btn" @click="inti"><i class="el-icon-search"></i>搜索</el-button>
      </div>
    </div>
    <div class="chart-box">
      <div class="list">
        <div v-for="(itm,idx) in list"
             :key="idx"
             class="item">
          <div class="item-img" @click="to(itm.id,'',itm.title,itm.cate_num)">
            <img :src="baseURL + itm.icon" alt="">
          </div>
          <div class="item-content">
            <b class="ovHide" @click="to(itm.id,'',itm.title,itm.cate_num)">{{itm.title}}</b>
<!--            <b v-if="itm.type !== 3" class="ovHide2" @click="to(itm.id,'',itm.title,itm.type,itm.cate_num)">{{itm.title}}</b>-->
            <p>
              <span @click="to(itm.id,'0',itm.title)">释义</span>
              <span @click="to(itm.id,'1',itm.title)">场景</span>
              <span @click="to(itm.id,'2',itm.title)">准据</span>
              <span @click="to(itm.id,'3',itm.title)">案例</span>
            </p>
          </div>
        </div>
      </div>
<!--      <el-empty v-if="bool" :image-size="200"></el-empty>-->
    </div>
  </div>
</template>
<script>
import {Index} from "@/api";
import {baseURL} from "@/config";

export default {
  name: "index",
  data() {
    return {
      baseURL: baseURL,
      keyword: '',
      list: [],
      detail: {},
      bool: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 2,
      act: -1,
      name: '知识产权与竞争纠纷'
    })
    this.inti()
  },
  methods: {
    // 获取列表
    async inti() {
      let _data = await Index(66,this.keyword);
      if (Number(_data.status) === 200) {
        if (_data.data.length < 1) {
          this.bool = true
          this.list = []
        } else {
          this.bool = false
          this.list = _data.data
        }
      } else {
        this.$message.error(_data.msg)
      }
    },

    to(id, type, title) {
      if (!this.user) return this.$message.info('请登录...')
      if (type !== '') {
        return this.$router.push({
          path: '/home/indexDetail',
          query: {
            id: id,
            testid: '',
            type: type,
            active:1
          }
        })
      }
      this.$confirm('是否进入测试?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$router.push({
          path: '/home/indexTest',
          query: {
            id: id,
            fname: title,
            active: 1
          }
        })
      }).catch(() => {
        this.$router.push({
          path: '/home/indexDetail',
          query: {
            id: id,
            testid: '',
            type: type,
            active: 1
          }
        })
      });
    }
  },
  watch: {},
  filters: {}
}
</script>

<style lang="scss" scoped>
.wapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  .num-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 20px 30px;
    background-color: #ffffff;
    border-radius: 10px;

    .search-box {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .search-input {
        flex: 1;
        height: 50px;
        line-height: 48px;
        background-color: #ffffff;
        border-radius: 10px;
        border: solid 1px #dae0e6;
        padding: 0 25px;
        font-size: 16px;
        color: #333333;
        border-radius: 10px 0px 0px 10px;
      }

      .search-btn {
        width: 100px;
        height: 50px;
        background-color: #0a2240;
        border-radius: 0px 10px 10px 0px;
        font-size: 16px;
        color: #ffffff;

        i {
          color: #ffffff;
          margin-right: 10px;
        }
      }
    }
  }

  .chart-box {
    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    margin-top: 20px;
    padding: 15px 10px;
    flex: 1;

    .list {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .item {
        width: 232px;
        height: 76px;
        background-color: #f4f9ff;
        border-radius: 10px;
        margin-bottom: 13px;
        margin-right: 12px;
        padding: 15px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        &:nth-child(4n) {
          margin-right: 0;
        }

        &:hover {
          transform: scale(1.15);
          background-color: #ffffff;
          box-shadow: 0px 7px 18px 0px rgba(73, 88, 107, 0.34);

          .item-content {
            b {
              font-size: 18px;
              color: #333333;
              font-weight: bold;
            }

            p {
              display: flex;
            }
          }
        }

        .item-img {
          width: 37px;
          height: 37px;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .item-content {
          flex: 1;
          width: 0;
          padding-left: 10px;

          b {
            font-size: 16px;
            color: #000000;
            display: block;
            font-weight: normal;
            text-align: left;
          }

          p {
            display: none;
            width: 100%;
            //display: flex;
            justify-content: flex-start;
            align-items: center;

            span {
              font-size: 14px;
              color: #444444;
              line-height: 22px;
              border-bottom: 1px solid #444444;
              margin-right: 10px;

              &:hover {
                color: #ff9600;
                border-color: #ff9600;
              }
            }
          }
        }
      }
    }
  }
}
</style>


